import CrudModule from "../components/CrudModule";

const STATUS = [
  { value: "scheduled", label: "Scheduled" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
  { value: "overdue", label: "Overdue" },
];

export default function MaintenancePage() {
  return (
    <CrudModule
      testidPrefix="maintenance"
      resource="maintenance"
      overline="FLEET HEALTH"
      title="Maintenance Schedule"
      subtitle="Preventive service reminders and shop coordination — with AI-drafted alerts."
      aiCategory="maintenance_reminder"
      aiContextFields={["truck_number", "service_type", "due_date", "mileage", "status"]}
      primaryField="truck_number"
      initialForm={{ status: "scheduled", mileage: 0 }}
      fields={[
        { key: "truck_number", label: "Truck #", required: true },
        { key: "service_type", label: "Service type", required: true, placeholder: "Oil change, DOT inspection..." },
        { key: "due_date", label: "Due date", type: "date", required: true },
        { key: "mileage", label: "Mileage", type: "number" },
        { key: "status", label: "Status", type: "select", options: STATUS },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "truck_number", label: "TRUCK" },
        { key: "service_type", label: "SERVICE" },
        { key: "due_date", label: "DUE" },
        { key: "mileage", label: "MILEAGE", render: (r) => <span className="font-mono text-xs">{r.mileage?.toLocaleString?.() || 0} mi</span> },
        { key: "status", label: "STATUS" },
      ]}
    />
  );
}
